export default function authHeader(token) {
  if ( token ) {
    return { 'X-Access-Token': token }
  } else {
    return {};
  }
}
